import { defineComponent } from "vue";
import { Container } from "aurelia-dependency-injection";

import { TaskService } from "../../../../../services/task.service";
import { ToastrService } from "../../../../../services/toastr.service";
import {
    IEvvHcTaskDetailsPayload,
    IVisitEvvHomeCare
} from "../../../../../resources-vue/vue-interfaces/i-visit-evv-hc";
import { formatDateFromDate, formatingDateOrTime } from "../../../../../common/vue-helpers/modifiers/value-modifier";

import FormSection from "../../../../../resources-vue/vue-custom-elements/FormSection/FormSection.vue";
import CommentInput from "../../../../../resources-vue/vue-custom-elements/CommentInput/CommentInput.vue";

export default defineComponent({
    components: {
        FormSection,
        CommentInput
    },

    props: {
        visitDetails: {
            type: Object
        },
        cancel: {
            type: Function
        },
        ok: {
            type: Function
        }
    },

    data(vm) {
        return {
            _taskService: null,
            _toastrService: null,
            evvDetails: null as IVisitEvvHomeCare,
            isLoading: false as boolean,
            isData: false as boolean,
            isEditing: false as boolean,
            formatDateFromDate,
            formatingDateOrTime
        };
    },

    async created() {
        this._taskService = Container.instance.get(TaskService);
        this._toastrService = Container.instance.get(ToastrService);
        Object.assign(this.visitDetails, {});
        await this.getEvvDetails();
    },

    methods: {
        async getEvvDetails() {
            try {
                this.isLoading = true;
                const payload: IEvvHcTaskDetailsPayload = {
                    application: this.visitDetails.Application,
                    agencyId: this.visitDetails.AgencyId,
                    taskId: this.visitDetails.Id,
                    isAgencyHasEvvIntegration: this.visitDetails.IsAgencyHasEvvIntegration,
                    evvStatus: Number(this.visitDetails.EvvStatus)
                };
                this.evvDetails = await this._taskService.getEvvTaskDetails(payload);
                if (this.evvDetails) {
                    this.isData = true;
                }
            } catch (error) {
                console.log(error);
            } finally {
                this.isLoading = false;
            }
        },

        formatHcEvvDate(date: any, isCollected: boolean = true) {
            if (date && date !== "0001-01-01T00:00:00") {
                return formatingDateOrTime(date, "MM/DD/YYYY hh:mm A");
            }
            return isCollected ? "Not Collected" : "Pending";
        },

        closeDialog() {
            this.cancel();
        }
    }
});
